
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({})
export default class EnvCompanySelect extends Vue {

  @Getter private companiesList: any[];
  @Getter private userCompaniesIds: (right?: string) => number[];
  @Getter private envCompanyId: number|null;

  get displayExternalCompanyMessage(): boolean {
    return this.envCompanyId
      && this.userCompaniesIds()?.length
      && !this.userCompaniesIds().includes(this.envCompanyId);
  }

  get companies() {
    return this.companiesList.map((c) => ({
      ...c,
      disabled: !!c.blockedAt,
    }));
  }

  private async selectCompany(selectedCompany) {
    if (selectedCompany?.id && selectedCompany.id !== this.envCompanyId) {
      await this.$store.dispatch("changeEnvCompanyId", selectedCompany.id);
      // No need to change page on the main dashboards (just reload page)
      const noRedirectPages = ["keys", "key-access", "relays", "contacts", "planning"];
      // Redirect user to corresponding dashboard
      if (this.$router.currentRoute.name === "relay") {
        // Relays
        await this.$router.push({name: "relays"});
      } else if (!noRedirectPages.includes(this.$router.currentRoute.name)) {
        // Default redirect to keys dashboard
        await this.$router.push({name: "keys"});
      }
      // Hard refresh to prevent any mix between data
      window.location.reload();
    }
  }
}
